export type PermissionTree = {
    // [PermissionType.System]: {
    //     [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
    //     [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    //     [PermissionLevel.Manage]: [PermissionType, PermissionLevel][]
    // }
    [PermissionType.Shop]: {
        [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
        [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    }
    [PermissionType.Resource]: {
        [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
        [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    }
    // [PermissionType.Service]: {
    //     [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
    //     [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    // }
    [PermissionType.Location]: {
        [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
        [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    }
    [PermissionType.Appointment]: {
        [PermissionLevel.Read  ]: [PermissionType, PermissionLevel][]
        [PermissionLevel.Write ]: [PermissionType, PermissionLevel][]
    }
}

export enum PermissionType {
    // System = 'System',
    Shop = 'Shop',
    // User = 'User',
    Location = 'Location',
    // Service = 'Service',
    Resource = 'Resource',
    Appointment = 'Appointment',
    // Flow = 'Flow'
}

export enum PermissionLevel {
    Read = 'Read',
    Write = 'Write'
}
